'use client';

import { useSyncExternalStore } from 'react';

/**
 * Which HITL tool calls have finished their pre-approval data fetch (e.g. reading the user's
 * current contact values). The card owns the fetch, but the activity trail needs the signal too —
 * to show a "fetching" phase while the read is in flight and switch to "awaiting approval" only
 * once the card is on screen. A tiny reactive store keyed by `toolCallId` (session-scoped;
 * nothing persisted).
 */
const ready = new Set<string>();
const listeners = new Set<() => void>();

export function markToolPhaseReady(toolCallId: string): void {
  if (!toolCallId || ready.has(toolCallId)) return;
  ready.add(toolCallId);
  for (const l of listeners) l();
}

export function useToolPhaseReady(toolCallId: string): boolean {
  return useSyncExternalStore(
    cb => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => ready.has(toolCallId),
    () => ready.has(toolCallId),
  );
}
